// src/context/DataProvider.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Datacontext } from "./Datacontext";
import { toast } from "react-toastify";

export function DataProvider({ children }) {
  const [blogs, setBlogs] = useState([]);
  const [magazines, setMagazines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [highlights,setHighlights]=useState([]);

  const fetchAllData = useCallback(async () => {
    setLoading(true);
    try {
      const [blogsRes, magazinesRes,highlightsRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/blogs`),
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/magazines`),
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/highlights`),
      ]);

      if (!blogsRes.ok || !magazinesRes.ok||!highlightsRes.ok) {
        throw new Error("Failed to fetch data");
      }

      const blogsData = await blogsRes.json();
      const magazinesData = await magazinesRes.json();
      const highlightsData=await highlightsRes.json();

      const blogList = Array.isArray(blogsData) ? blogsData : blogsData.data || [];
      const magazineList = Array.isArray(magazinesData) ? magazinesData : magazinesData.data || [];
      const highlightsList = Array.isArray(highlightsData) ? highlightsData : highlightsData.data || [];

      setBlogs(blogList);
      setMagazines(magazineList);
      setHighlights(highlightsList);
    } catch (err) {
      console.error("Data fetch error:", err);
      toast.error("Failed to load content. Please refresh.");
      setBlogs([]);
      setMagazines([]);
      setHighlights([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch once when app starts
  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  return (
    <Datacontext.Provider
      value={{
        blogs,
        setBlogs,
        magazines,
        setMagazines,
        loading,
        highlights,
        setHighlights,
        refetch: fetchAllData, // ← Super important for admin pages!
      }}
    >
      {children}
    </Datacontext.Provider>
  );
}